var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("h5", [_vm._v("Начисления по Контакту:")]),
      _vm._v(" "),
      _c("tableOperations", {
        attrs: { items: _vm.items },
        on: {
          "update-operations-table": function ($event) {
            return _vm.getItems(_vm.operationDefault.contact)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-button",
        {
          on: {
            click: function ($event) {
              return _vm.getItems(_vm.operationDefault.contact)
            },
          },
        },
        [_vm._v("Обновить данные")]
      ),
      _vm._v(" "),
      _c("h5", [_vm._v("Добавить начисление по задаче")]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.operationDefault.dataReady
            ? _c("addOperation", {
                attrs: { operationDefault: _vm.operationDefault, mode: "add" },
                on: {
                  "update-operations-table": function ($event) {
                    return _vm.getItems(_vm.operationDefault.contact)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }